export const UCF_GOLD = "#FFC904";
export const UCF_BLACK = "#000000";
export const GRAY = "gray";
export const GRAYBLACK = "#404243"